import Typography from "@mui/material/Typography";
import React from "react";
import SubscriptionBlock from "../Components/SubscriptionBlock";
import { useAuthenticator } from "@aws-amplify/ui-react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

interface SubscriptionObject {
    subscribed: boolean;
    subscriptionActive: boolean;
}

interface SubscriptionProps {
    customerId: string;
    customerEmail: string;
    subscription: SubscriptionObject;
}

const Subscription: React.FC<SubscriptionProps> = (props: SubscriptionProps) => {
    const { signOut } = useAuthenticator((context) => [context.user]);

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "grey.100",
                p: 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    p: 4,
                    width: "100%",
                    maxWidth: 480,
                    borderRadius: 2,
                }}
            >
                <Box sx={{ textAlign: "center", py: 2 }}>
                    <Typography variant="h5" fontWeight="bold" color="primary">
                        Simple Invoicing
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Manage your pet service business
                    </Typography>
                </Box>
                <Stack spacing={2} alignItems="center" textAlign="center">
                    {!props.subscription.subscribed ? (
                        <>
                            <Typography variant="h5" fontWeight="bold">
                                Nearly There...
                            </Typography>
                            <Typography variant="subtitle1">Use the button below to start your free trial</Typography>
                            <Typography variant="body2" color="text.secondary">
                                By subscribing, you will get access to all the features of the application.
                                <br />
                                You can cancel your subscription at any time.
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                We want you to love our product and we don't believe in asking you to subscribe and then
                                hoping you forget to cancel so we don't take any payment information at this point. You
                                will receive an email requesting payment details at the end of the 90 day trial period.
                            </Typography>
                            <SubscriptionBlock
                                subscription={{
                                    subscribed: false,
                                    customerId: props.customerId,
                                    customerEmail: props.customerEmail,
                                }}
                            />
                        </>
                    ) : (
                        <>
                            <Typography variant="h5" fontWeight="bold">
                                Manage Subscription
                            </Typography>
                            <Typography variant="subtitle1">Use the button below to update your subscription</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Some details are missing from your account
                            </Typography>
                            <SubscriptionBlock
                                subscription={{
                                    subscribed: true,
                                    customerId: props.customerId,
                                    customerEmail: props.customerEmail,
                                }}
                            />
                        </>
                    )}
                    <Button onClick={signOut} color="inherit">
                        Sign Out
                    </Button>
                </Stack>
            </Paper>
        </Box>
    );
};

export default Subscription;
